<template>
  <div class="header">
<!--文案 -->
<div class="logo-section">
  <div class="logo-text">
    <div class="logo-title">河南科技成果与知识产权交易平台</div>
    <div class="logo-subtitle">一站式技术交易
</div>
  </div>
</div>

<!-- 左侧tab -->
<div class="tabs">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="首页" name="1"></el-tab-pane>
 
    <el-tab-pane label="数据资源" name="3"></el-tab-pane>
    <el-tab-pane label="交易大厅" name="9"></el-tab-pane>
    <el-tab-pane label="特色产业" name="7"></el-tab-pane>
    <el-tab-pane label="科创金融" name="12"></el-tab-pane>
    <el-tab-pane label="知识产权运营服务" name="10"></el-tab-pane>
    <el-tab-pane label="科技成果转化" name="11"></el-tab-pane>
    <el-tab-pane label="知识图谱" name="15"></el-tab-pane>
    <el-tab-pane label="会员单位" name="13"></el-tab-pane>
 
    <el-tab-pane label="交易规则" name="8"></el-tab-pane>
    <el-tab-pane label="媒体中心" name="6"></el-tab-pane>

<!--     
    <el-tab-pane label="交易中心" name="2"></el-tab-pane>
    <el-tab-pane label="科创企业" name="4"></el-tab-pane>
    <el-tab-pane label="在线竞价" name="5"></el-tab-pane>




    <el-tab-pane label="科创金融" name="12"></el-tab-pane>

    <el-tab-pane label="路演大厅" name="14"></el-tab-pane> -->

    
  </el-tabs>
</div>

<!-- 右侧登录注册按钮 -->
<div class="auth-buttons">
  <el-dropdown v-if="userInfo" @command="handleUserCommand">
    <span class="user-info-btn">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style="margin-right:6px;vertical-align:middle;">
        <circle cx="9" cy="6" r="3.5" stroke="rgba(255,255,255,0.9)" stroke-width="1.4"/>
        <path d="M2 17c0-3.866 3.134-7 7-7s7 3.134 7 7" stroke="rgba(255,255,255,0.9)" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
      {{ userInfo.nickName || userInfo.userName }}
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="margin-left:4px;vertical-align:middle;">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="rgba(255,255,255,0.7)" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="admin">管理后台</el-dropdown-item>
        <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <template v-else>
    <button class="auth-btn login-btn" @click="$router.push('/login?redirect=' + $route.fullPath)">登录</button>
    <div class="divider"></div>
    <button class="auth-btn register-btn" @click="registerDialogVisible = true">注册</button>
  </template>
</div>

<!-- 注册弹窗 -->
<el-dialog v-model="registerDialogVisible" title="用户注册" width="500px" :before-close="handleRegisterClose" class="register-dialog" append-to-body>
  <el-form ref="registerForm" :model="registerForm" :rules="registerRules" label-position="top">
    <el-form-item label="账号" prop="username">
      <el-input v-model="registerForm.username" placeholder="请输入账号"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input v-model="registerForm.password" :type="showPwd ? 'text' : 'password'" placeholder="请输入密码">
        <template #suffix>
          <svg @click="showPwd = !showPwd" style="cursor:pointer;width:18px;height:18px;" viewBox="0 0 24 24" fill="none">
            <template v-if="showPwd">
              <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z" stroke="#9CA3AF" stroke-width="1.8"/>
              <circle cx="12" cy="12" r="3" stroke="#9CA3AF" stroke-width="1.8"/>
            </template>
            <template v-else>
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
              <line x1="1" y1="1" x2="23" y2="23" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
            </template>
          </svg>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input v-model="registerForm.confirmPassword" :type="showConfirmPwd ? 'text' : 'password'" placeholder="请再次输入密码">
        <template #suffix>
          <svg @click="showConfirmPwd = !showConfirmPwd" style="cursor:pointer;width:18px;height:18px;" viewBox="0 0 24 24" fill="none">
            <template v-if="showConfirmPwd">
              <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z" stroke="#9CA3AF" stroke-width="1.8"/>
              <circle cx="12" cy="12" r="3" stroke="#9CA3AF" stroke-width="1.8"/>
            </template>
            <template v-else>
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
              <line x1="1" y1="1" x2="23" y2="23" stroke="#9CA3AF" stroke-width="1.8" stroke-linecap="round"/>
            </template>
          </svg>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="realName">
      <el-input v-model="registerForm.realName" placeholder="请输入真实姓名"></el-input>
    </el-form-item>
    <el-form-item label="联系方式" prop="contactPhone">
      <el-input v-model="registerForm.contactPhone" placeholder="请输入手机号码"></el-input>
    </el-form-item>
    <el-form-item label="所属企业" prop="enterpriseName">
      <el-input v-model="registerForm.enterpriseName" placeholder="请输入所属企业名称"></el-input>
    </el-form-item>
  </el-form>
  <template #footer>
    <el-button @click="handleRegisterClose">取消</el-button>
    <el-button type="default" :loading="registerLoading" @click="submitRegister(false)">注册</el-button>
    <el-button type="primary" :loading="registerLoading" @click="submitRegister(true)">注册并登录</el-button>
  </template>
</el-dialog>

  </div>

  <div style="height:90px"></div>

    <IndexContent v-if="activeName=='1'" @switchTab="handleTabSwitch"></IndexContent>
<JyzxContent  v-if="activeName=='2'"  :idsss="activeName"></JyzxContent>
<sjzyContent v-if="activeName=='3'" :idsss="activeName" :initialTab="sjzyInitialTab"></sjzyContent>
<!-- <kcqyContent v-if="activeName=='4'"></kcqyContent> -->
<zxjjContent  v-if="activeName=='5'"></zxjjContent>
<mtzxContent  v-if="activeName=='6'"></mtzxContent>
<tscyContent  v-if="activeName=='7'"></tscyContent>
<jygzContent v-if="activeName=='8'"></jygzContent>
<jydtContent v-if="activeName=='9'" :idsss="activeName" :initialType="jydtInitialType"></jydtContent>
<zscqyyfwContent v-if="activeName=='10'"></zscqyyfwContent>
<kjcgzhContent v-if="activeName=='11'"></kjcgzhContent>
<kcjrContent  v-if="activeName=='12'" :idsss="activeName" :initialTab="kcjrInitialTab"></kcjrContent>
<hydwContent v-if="activeName=='13'" :idssss="activeName"></hydwContent>
<lydtContent v-if="activeName=='14'"></lydtContent>
<zstpContent v-if="activeName=='15'"></zstpContent>
<FootBut @updatemsg="handleMsg" :idssss="activeName" ></FootBut>
  
</template>

<script>

import FootBut from '@/components/foot.vue'
import IndexContent from '@/components/index.vue'
import JyzxContent from '@/components/jyzx.vue'
import sjzyContent from '@/components/sjzy.vue'
import jydtContent from '@/components/jydt.vue'
import zscqyyfwContent from '@/components/zscqyyfw.vue'
import kjcgzhContent from '@/components/kjcgzh.vue'
// import kcqyContent from '@/components/kcqy.vue'
import zxjjContent from '@/components/zxjj.vue'
import mtzxContent from '@/components/mtzx.vue'
import tscyContent from '@/components/tscy.vue'
import jygzContent from '@/components/jygz.vue'
import kcjrContent from '@/components/kcjr.vue'
import hydwContent from '@/components/hydw.vue'
import lydtContent from '@/components/lydt.vue'
import zstpContent from '@/components/zstp.vue'

// import PcmxFrom from './pcmxfrom.vue'

import { getAction, postAction } from '@/api/requests'
import Cookies from 'js-cookie'

export default {
  name: 'HomeView',
  components: {
    FootBut,
    IndexContent,
    JyzxContent,
    sjzyContent,
    jydtContent,
    zscqyyfwContent,
    kjcgzhContent,
    // kcqyContent,
    zxjjContent,
    mtzxContent,
    tscyContent,
    jygzContent,
    kcjrContent,
    hydwContent,
    lydtContent,
    zstpContent
  },
  data(){
    return{
      activeName: '1',
      tabmoren:3,
      zwtab:1,
      sjzyInitialTab: '',
      kcjrInitialTab: '',
      jydtInitialType: '',
      userInfo: null,
      registerDialogVisible: false,
      registerLoading: false,
      showPwd: false,
      showConfirmPwd: false,
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        realName: '',
        contactPhone: '',
        enterpriseName: ''
      },
      registerRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        enterpriseName: [{ required: true, message: '请输入所属企业', trigger: 'blur' }]
      }
    }
  },
  created(){
    if(this.$route.query.id){
      this.activeName = this.$route.query.id
    }
    this.checkLogin()
  },
  onMounted(){

  },
  methods:{
    handleRegisterClose() {
      this.registerDialogVisible = false
      this.$refs.registerForm && this.$refs.registerForm.resetFields()
      this.showPwd = false
      this.showConfirmPwd = false
    },
    submitRegister(andLogin) {
      this.$refs.registerForm.validate(valid => {
        if (!valid) return
        if (this.registerForm.confirmPassword !== this.registerForm.password) {
          this.$message.error('两次输入的密码不一致')
          return
        }
        this.registerLoading = true
        postAction('/register', {
          username: this.registerForm.username,
          password: this.registerForm.password,
          realName: this.registerForm.realName,
          contactPhone: this.registerForm.contactPhone,
          enterpriseName: this.registerForm.enterpriseName
        }).then(res => {
          this.registerLoading = false
          if (res.code === 200) {
            this.$message.success('注册成功')
            this.handleRegisterClose()
            if (andLogin) {
              this.$router.push({
                path: '/login',
                query: {
                  username: this.registerForm.username,
                  password: this.registerForm.password
                }
              })
            }
          } else {
            this.$message.error(res.msg || '注册失败')
          }
        }).catch(() => {
          this.registerLoading = false
          this.$message.error('注册失败，请稍后重试')
        })
      })
    },
    checkLogin() {
      const token = Cookies.get('Admin-Token')
      if (token) {
        getAction('/getInfo').then(res => {
          if (res.code === 200) {
            this.userInfo = res.user
          } else {
            // token 失效
            Cookies.remove('Admin-Token')
            this.userInfo = null
          }
        }).catch(() => {
          Cookies.remove('Admin-Token')
          this.userInfo = null
        })
      }
    },
    handleUserCommand(command) {
      if (command === 'admin') {
        window.open('http://39.105.114.210:13307', '_blank')
      } else if (command === 'logout') {
        getAction('/logout').then(() => {}).catch(() => {})
        Cookies.remove('Admin-Token')
        this.userInfo = null
        this.$message.success('已退出登录')
      }
    },
    handleMsg(val){
      console.log(val,'val');
this.activeName = val
},
    handleTabSwitch(tabName, initialTab = '') {
      console.log(tabName,'切换到 tab', initialTab);
      this.activeName = tabName
      if(tabName === '3' && initialTab){
        this.sjzyInitialTab = initialTab
      }
      if(tabName === '12' && initialTab){
        this.kcjrInitialTab = initialTab
      }
      if(tabName === '9' && initialTab){
        this.jydtInitialType = initialTab
      }
    },
    handleClick(tab, event) {
        console.log(tab, event)
        // this.getapi()
      },
      // 接口调用模版
    getapi(){
      let data = {
        pageNum: 1,
    pageSize: 10,
      }
      getAction("/edu/expert/list", data).then(res => {
        console.log(res)
     
      })
    }
  }
}
</script>

<style>

body{
  background-color: black;
}
::-webkit-scrollbar {width:0 !important;}
::-webkit-scrollbar{ width:0 !important;}

/* 注册弹窗样式 */
.register-dialog .el-dialog__header {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
  padding: 24px 32px !important;
  border-radius: 16px 16px 0 0 !important;
  margin: 0 !important;
}
.register-dialog .el-dialog__title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #FFFFFF !important;
}
.register-dialog .el-dialog__headerbtn {
  background: rgba(255,255,255,0.2) !important;
  position: absolute; top: 24px; right: 32px;
  width: 36px; height: 36px; border-radius: 50%;
}
.register-dialog .el-dialog__close { color: #FFFFFF !important; }
.register-dialog .el-dialog__body { padding: 24px 32px 10px; }
.register-dialog .el-dialog__footer { padding: 10px 32px 24px; }

.header{
  background: linear-gradient( 360deg, rgba(0,23,47,0.5) 0%, rgba(0,1,2,0.5) 100%);
    backdrop-filter: blur(5px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 0.4rem -1px;
    transition: opacity 0.7s ease-in-out;
box-sizing: border-box;
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  width: 100%; /* 元素宽度 */
  height:90px; /* 元素高度 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index:999;
}
.headertop{
  width: 100%;
  box-sizing: border-box;
  height: 70px;
  display: flex;
  justify-content:space-between;
  /* border-top: 1px solid var(---01, rgba(255, 255, 255, 0.08)); */
border-bottom: 1px solid var(---01, rgba(255, 255, 255, 0.08));

}
.nameimg{
  width: 97px;
  height: 40px;
  margin-left: 24px;
  margin-top: 15px;
}

.juznpcimg{
  width: 196px;
  height: 33px;
  margin-left: 16.5px;
  margin-top: 14px;
}
/* logo 区域样式 */
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 40px;
  flex-shrink: 0;
}

.logo-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.logo-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logo-title {
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.logo-subtitle {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
}

.tabs{
  flex: 1;
  margin-left: 40px;
  margin-right: 20px;
  display: flex;
  align-items: center;
}

/* 右侧登录注册按钮 */
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0;
  margin-right: 40px;
}

.auth-btn {
  padding: 8px 20px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s;
}

.auth-btn:hover {
  color: #FFFFFF;
}

.divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.3);
}

.login-btn {
  padding-right: 16px;
}

.register-btn {
  padding-left: 16px;
}

.user-info-btn {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s;
}

.user-info-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}

</style>


<style scoped>

/* 去掉长分割线 */
:deep(.el-tabs__nav-wrap::after) {
  display: none !important;
}

/* 激活状态的下划线 */
:deep(.el-tabs__active-bar) {
  height: 3px;
  background: linear-gradient(90deg, #3B82F6 0%, #60A5FA 100%);
  border-radius: 2px;
}

/* 标签项样式 */
::v-deep .el-tabs {
  height: 100%;
  display: flex;
  align-items: center;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap {
  display: flex;
  align-items: center;
}

::v-deep .el-tabs__item {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px;
  height: 90px;
  line-height: 90px;
  transition: all 0.3s;
}

/* 标签项悬停 */
::v-deep .el-tabs__item:hover {
  color: rgba(255, 255, 255, 0.9);
}

/* 激活状态的标签 */
::v-deep .el-tabs__item.is-active {
  color: #FFFFFF;
  font-weight: 500;
}

.zwtab{
  width: 124px;
  height: 42px;
  border-radius: 99px;
background: var(---03--, rgba(255, 255, 255, 0.12));
 display: flex;
 justify-content: space-around;
 align-items: center;
margin-top: 13px;

}

.zwtab1{
  width: 52px;
  height: 32px;
display: flex;
justify-content: center;
align-items: center;
color: rgba(255, 255, 255, 0.40);

}
.zwtab2{
  width: 52px;
  height: 32px;
  border-radius: 49px;
background: #1F5EFF;
display: flex;
justify-content: center;
align-items: center;
color: var(---white, var(---, #FFF));
font-family: "HarmonyOS Sans SC";
font-size: 14px;
font-style: normal;
font-weight: 400;

}
.zwtabs{
  width: 30px;
  height: 2px;
  background-color: #313C56;
}
.lefts{
  display: flex;
}
.rights{
  display: flex;
  margin-right: 24px;
}
</style>
